module.exports = __webpack_public_path__ + "img/icon-compass.bf8b8687.svg";